import { render, staticRenderFns } from "./sizes.vue?vue&type=template&id=a51fe52e&"
import script from "./sizes.vue?vue&type=script&lang=js&"
export * from "./sizes.vue?vue&type=script&lang=js&"
import style0 from "./sizes.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports